import { selectEditorPreviewWidgetComponentProps, selectEditorSettingsColumnsOptions } from "../draft-selectors";
import { updateOrAddColumnOptionState, updateOrAddColumnTemplate, updateOrAddDatapointRequest } from "../helpers";
import { componentPropsPatcher } from "store/current-dashboard/types";
const addComponentPropsPatcherAddSelectedGroupByColumns = (widgetComponentProps) => {
    if (!widgetComponentProps.componentPropsPatchers) {
        widgetComponentProps.componentPropsPatchers = [];
    }
    if (!widgetComponentProps.componentPropsPatchers.some((p) => p.patcher === componentPropsPatcher.addSelectedGroupByColumns)) {
        widgetComponentProps.componentPropsPatchers.push({ patcher: componentPropsPatcher.addSelectedGroupByColumns });
    }
};
const addComponentPropsPatcherMoveSelectedGroupByColumns = (widgetComponentProps) => {
    if (!widgetComponentProps.componentPropsPatchers) {
        widgetComponentProps.componentPropsPatchers = [];
    }
    if (!widgetComponentProps.componentPropsPatchers.some((p) => p.patcher === componentPropsPatcher.moveSelectedGroupByColumns)) {
        widgetComponentProps.componentPropsPatchers.push({
            argument: {
                keepOriginalDimensionsOrder: true
            },
            patcher: componentPropsPatcher.moveSelectedGroupByColumns
        });
    }
};
export const addSettingsGroupingOptionsDatapointsReducer = (state, action) => {
    const columnOptions = selectEditorSettingsColumnsOptions(state);
    if (!state.editor?.settings || !columnOptions) {
        return;
    }
    if (!state.editor.settings.groupingOptionsDatapoints) {
        state.editor.settings.groupingOptionsDatapoints = [];
    }
    const widgetComponentProps = selectEditorPreviewWidgetComponentProps(state);
    if (!columnOptions.some((c) => c.id === action.payload.id)) {
        const { groupingOptionsDatapoints } = state.editor.settings;
        groupingOptionsDatapoints.push(action.payload.isCustomDatapoint
            ? {
                customDatapoint: action.payload.datapoint,
                id: action.payload.id,
                name: action.payload.name
            }
            : {
                id: action.payload.id,
                name: action.payload.name,
                standardDatapoint: action.payload.datapoint
            });
        addComponentPropsPatcherAddSelectedGroupByColumns(widgetComponentProps);
    }
    addComponentPropsPatcherMoveSelectedGroupByColumns(widgetComponentProps);
    updateOrAddColumnOptionState(state, action.payload);
    updateOrAddDatapointRequest(state, action.payload);
    updateOrAddColumnTemplate(state, action.payload);
};
export const addSettingsGroupingOptionsReducer = (state, action) => {
    if (action.payload) {
        for (const option of action.payload) {
            const aaction = {
                payload: option,
                type: ""
            };
            addSettingsGroupingOptionsDatapointsReducer(state, aaction);
        }
    }
};
